import React, { forwardRef, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TitleWrapperStyled, TitleStyled, styles } from "./styles";
// @material-ui/icons
import AddIcon from "@material-ui/icons/Add";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ReactTable from "react-table";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import RegularButton from "components/CustomButtons/Button";
import { Grid } from "@material-ui/core";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { animations } from "helpers/animations";
import { useSearch } from "hooks/useSearch";
import { useSelector } from "react-redux";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";
import { blue } from "@material-ui/core/colors";
import { CountersComponent } from "./CountersComponent";

const useStyles = makeStyles(styles);
const CardTable = forwardRef((props, _) => {
  const {
    children,
    data = [],
    reference = null,
    hasHeader = false,
    icon = null,
    title = "",
    title2 = "",
    onChangePage,
    hasBackButton = false,
    columns = [],
    next = "Siguiente",
    prev = "Anterior",
    rowText = "",
    blockBtn = false,
    hasControl = false,
    controls,
    isLoading = false,
    tableContent = null,
    tablePanel = null,
    rowStyle = true,
    thWidth = "auto",
    tableKey = "",
    onPageSize = null,
    onPage = null,
    onSort = null,
    onFilter,
    controlProps = {},
    style={},
    gridTable={},
    panelStyle={},
    counters = []
  } = props;
  const classes = useStyles();
  const headerStyle = {
    headerStyle: styles().thTable,
  };

  const { configTables } = useSelector(({ search }) => search);
  const { isDark: isDarkMode } = useThemeMode();

  const [mapColumns, setMapColumns] = useState([]);
  const {
    handlePageSize: defaultHandlePageSize,
    handlePage: defaultHandlePage,
    handleSort: defaultHandleSort,
    handleFilter: defaultHandleFilter,
  } = useSearch(tableKey);

  const handlePageSize = onPageSize || defaultHandlePageSize;
  const handlePage = onPage || defaultHandlePage;
  const handleSort = onSort || defaultHandleSort;
  const handleFilter = onFilter || defaultHandleFilter;

  const restConfig = configTables[tableKey]?.pages
    ? { pages: configTables[tableKey]?.pages }
    : {};

  useEffect(() => {
    columns &&
      columns.length > 0 &&
      setMapColumns(
        columns.map((column) => {
          return {
            ...column,
            width: thWidth,
            ...headerStyle,
          };
        })
      );
    // eslint-disable-next-line
  }, []);

  return (
    <Card style={{
        ...style
      }}>
      {hasHeader && (
        <CardHeader color="info" icon>
          {icon && <CardIcon color="info">{icon}</CardIcon>}
          <TitleWrapperStyled>
            <TitleStyled>
              {title} {title2}
            </TitleStyled>
            {!blockBtn && (
              <Button
                justIcon
                round
                color="info"
                onClick={() => (onChangePage ? onChangePage() : null)}
              >
                {hasBackButton ? (
                  <ArrowBackIcon className={classes.buttonIcon} />
                ) : (
                  <AddIcon className={classes.buttonIcon} />
                )}
              </Button>
            )}
            {hasControl ? (
              <form
                style={{
                  float: "right",
                  display: "flex",
                  gap: 8,
                  paddingTop: 16,
                  ...controlProps,
                }}
              >
                {controls}
              </form>
            ) : null}
          </TitleWrapperStyled>
        </CardHeader>
      )}
      <CardBody className={classes.cardBody} >
        {tableContent}
        { counters.length > 0 && (
          <CountersComponent counters={counters}/>
        ) }
        <Grid container spacing={4} style={{ overflow: "scroll", ...panelStyle }}>
          {tablePanel && (
            <Grid item xs={12} sm={3}>
              {tablePanel}
            </Grid>
          )}
          {isLoading ? (
            <LoadingComponent />
          ) : (
            <Grid
              item
              xs={12}
              sm={tablePanel ? 9 : 12}
              style={{ marginTop: 72, ...gridTable }}
            >
              <ReactTable
                className={animations.fadeIn}
                ref={reference}
                columns={mapColumns}
                data={data}
                previousText={
                  <div>
                    <RegularButton fullWidth color="info">
                      {prev}
                    </RegularButton>
                  </div>
                }
                nextText={
                  <div>
                    <RegularButton fullWidth color="info">
                      {next}
                    </RegularButton>
                  </div>
                }
                noDataText="Sin Datos"
                pageText="Pagina"
                ofText="de"
                rowsText={rowText}
                pageSize={configTables[tableKey]?.pageSize}
                page={configTables[tableKey]?.page}
                sorted={configTables[tableKey]?.sorted}
                filtered={configTables[tableKey]?.filtered}
                {...restConfig}
                onPageSizeChange={(e) => handlePageSize(e, tableKey)}
                onPageChange={(e) => handlePage(e, tableKey)}
                onSortedChange={(e) => handleSort(e, tableKey)}
                onFilteredChange={(e) => handleFilter(e, tableKey)}
                getTheadThProps={() => ({
                  style: {
                    color: isDarkMode ? darkPalette.accent : blue[800],
                    fontWeight: "bold",
                  },
                })}
                {...props}
                getTrProps={(_, rowInfo) => {
                  if (!rowInfo) return isDarkMode ? { style: { backgroundColor: darkPalette.cardBg } } : {};

                  return {
                    style: {
                      backgroundColor:
                        rowStyle && rowInfo.viewIndex % 2 === 0
                          ? (isDarkMode ? darkPalette.altRowBg : "#DBEDFF")
                          : (isDarkMode ? darkPalette.cardBg : "white"),
                      margin: 0,
                    },
                  };
                }}
              >
                {children}
              </ReactTable>
            </Grid>
          )}
        </Grid>
      </CardBody>
    </Card>
  );
});
export default React.memo(CardTable);
